import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AboutComponent} from './website/pages/about/about.component';
import {TermsAndConditionsComponent} from './website/pages/terms-and-conditions/terms-and-conditions.component';
import {PrivacyPolicyComponent} from './website/pages/privacy-policy/privacy-policy.component';
import {NotFoundComponent} from './website/pages/not-found/not-found.component';
import {HomeComponent} from './website/pages/home/home.component';
import {MasterComponent} from './website/template/master/master.component';
import {MerchantComponent} from "./website/pages/merchant/merchant.component";
import {LoginComponent} from "./website/pages/login/login.component";
import {MerchantHomeComponent} from "./merchant/pages/merchant-home/merchant-home.component";
import {MerchantLoginComponent} from "./merchant/pages/merchant-login/merchant-login.component";
import {MerchantSignupComponent} from "./merchant/pages/merchant-signup/merchant-signup.component";
import {ConfirmEmailComponent} from "./website/pages/confirm-email/confirm-email.component";
import {
  MerchantMoreInfoComponent
} from "./merchant/pages/merchant-signup/merchant-more-info/merchant-more-info.component";
import {
  MerchantContactInfoComponent
} from "./merchant/pages/merchant-signup/merchant-contact-info/merchant-contact-info.component";
import {
  MerchantReviewingAccountComponent
} from "./merchant/pages/merchant-signup/merchant-reviewing-account/merchant-reviewing-account.component";
import {
  MerchantEmailConfirmationComponent
} from "./merchant/pages/merchant-signup/merchant-email-confirmation/merchant-email-confirmation.component";
import {
  MerchantBasicInfoComponent
} from "./merchant/pages/merchant-signup/merchant-basic-info/merchant-basic-info.component";
import {
  MerchantLoginComponent as MerchantLoginDuringSignupComponent
} from "./merchant/pages/merchant-signup/merchant-login/merchant-login.component";
import {CommonModule} from '@angular/common';
import {MerchantMenuTabComponent} from "./website/pages/merchant/merchant-menu-tab/merchant-menu-tab.component";
import {MerchantHomeTabComponent} from "./website/pages/merchant/merchant-home-tab/merchant-home-tab.component";
import {
  MerchantImagesAndVideosTabComponent
} from "./website/pages/merchant/merchant-images-and-videos-tab/merchant-images-and-videos-tab.component";
import {MerchantListPageComponent} from "./website/pages/merchant-list-page/merchant-list-page.component";
import {ProductDetailsComponent} from "./website/pages/product-details/product-details.component";
import {MerchantReviewTabComponent} from "./website/pages/merchant/merchant-review-tab/merchant-review-tab.component";
import {
  MerchantLocationTabComponent
} from "./website/pages/merchant/merchant-location-tab/merchant-location-tab.component";
import {ContactUsComponent} from "./website/pages/contact-us/contact-us.component";
import {
  MerchantForgetPasswordComponent
} from "./merchant/pages/merchant-forget-password/merchant-forget-password.component";
import {
  MerchantEmailConfirmationPasswordComponent
} from "./merchant/pages/merchant-email-confirmation-password/merchant-email-confirmation-password.component";
import {
  MerchantCreateNewPasswordComponent
} from "./merchant/pages/merchant-create-new-password/merchant-create-new-password.component";
import {
  MerchantResendEmailConfirmationPasswordComponent
} from "./merchant/pages/merchant-resend-email-confirmation/merchant-resend-email-confirmation-password.component";
import {FaqsComponent} from "./website/pages/faqs/faqs.component";
import {CookiesPolicyComponent} from "./website/pages/cookies-policy/cookies-policy.component";
import {SignUpComponent} from "./website/pages/sign-up/sign-up.component";
import {CustomerBasicInfoComponent} from "./website/pages/sign-up/customer-basic-info/customer-basic-info.component";
import {
  CustomerEmailVerificationComponent
} from "./website/pages/sign-up/customer-email-verification/customer-email-verification.component";
import {
  CustomerForgetPasswordComponent
} from "./website/pages/sign-up/customer-forget-password/customer-forget-password.component";
import {CustomerProfileComponent} from "./website/pages/customer-profile/customer-profile.component";

const routes: Routes = [
    {
      path: '',
      component: MasterComponent,
      children: [
        {path: '', component: HomeComponent},
        {path: 'about', component: AboutComponent},
        {
          path: 'faqs',
          children: [
            {path: '', component: FaqsComponent},
            {path: 'users', component: FaqsComponent},
            {path: 'registration-and-onboarding', component: FaqsComponent},
            {path: 'product-listings', component: FaqsComponent},
            {path: 'pricing-and-payments', component: FaqsComponent},
            {path: 'order-management', component: FaqsComponent},
            {path: 'customer-support', component: FaqsComponent},
            {path: 'reviews-and-ratings', component: FaqsComponent},
            {path: 'safety-and-quality', component: FaqsComponent},
            {path: 'marketing-and-promotions', component: FaqsComponent},
            {path: 'policies-and-terms', component: FaqsComponent},
            {path: 'technical-issues', component: FaqsComponent},
            {path: 'future-developments', component: FaqsComponent},
            {path: 'miscellaneous', component: FaqsComponent},
          ]
        },
        {path: 'contact-us', component: ContactUsComponent},
        {path: 'login', component: LoginComponent},
        {
          path: 'customers/signup',
          component: SignUpComponent,
          children: [
            {path: '', component: CustomerBasicInfoComponent},
            {path: 'email-verification', component: CustomerEmailVerificationComponent},
            {path: 'email-confirmation/:token', component: CustomerEmailVerificationComponent},
            {path: 'customer-forget-password', component: CustomerForgetPasswordComponent},
          ]
        },
        {
          path: 'page/:slug',
          component: MerchantComponent,
          children: [
            {path: '', component: MerchantHomeTabComponent},
            {path: 'menu', component: MerchantMenuTabComponent},
            {path: 'gallery', component: MerchantImagesAndVideosTabComponent},
            {path: 'reviews', component: MerchantReviewTabComponent},
            {path: 'location', component: MerchantLocationTabComponent}
          ]
        },
        {path: 'email/confirm/:token', component: ConfirmEmailComponent},
        {path: 'restaurants', component: MerchantListPageComponent},
        {path: 'product/:id', component: ProductDetailsComponent},
        {path: 'terms-and-conditions', component: TermsAndConditionsComponent},
        {path: 'privacy-policy', component: PrivacyPolicyComponent},
        {path: 'cookies-policy', component: CookiesPolicyComponent},
        {
          path: 'merchants',
          children: [
            {path: '', component: MerchantHomeComponent},
            {path: 'login', component: MerchantLoginComponent},
            {path: 'forget-password', component: MerchantForgetPasswordComponent},
            {path: 'forget-password/confirmation', component: MerchantEmailConfirmationPasswordComponent},
            {path: 'forget-password/confirmation/:token', component: MerchantEmailConfirmationPasswordComponent},
            {path: 'new-password', component: MerchantCreateNewPasswordComponent},
            {path: 'new-password/:token', component: MerchantCreateNewPasswordComponent},
            {path: 'email-confirmation', component: MerchantResendEmailConfirmationPasswordComponent},
            {path: 'email-confirmation/:token', component: MerchantResendEmailConfirmationPasswordComponent},
            {
              path: 'signup',
              component: MerchantSignupComponent,
              children: [
                {path: '', component: MerchantBasicInfoComponent},
                {path: 'email-confirmation', component: MerchantEmailConfirmationComponent},
                {path: 'email-confirmation/:token', component: MerchantEmailConfirmationComponent},
                {path: 'login', component: MerchantLoginDuringSignupComponent},
                {path: 'more-info', component: MerchantMoreInfoComponent},
                {path: 'contact-info', component: MerchantContactInfoComponent},
                {path: 'reviewing-account', component: MerchantReviewingAccountComponent},
              ]
            }
          ]
        },
        {path: 'profile', component: CustomerProfileComponent},
        {
          path: '**', component: NotFoundComponent
        },
      ]
    },


  ]
;

@NgModule({
  imports: [RouterModule.forRoot(routes), CommonModule],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
